import React, {useState} from "react";
import {Typography} from "@mui/material";
import YourFilesLink from "../../components/yourFilesLink/yourFilesLink";
import SpinnerButton from "../../components/spinnerButton/spinnerButton";
import QuestionsBlurb from "../../components/questionsBlurb/questionsBlurb";
import * as wizardService from "../../services/wizards";

const renderItems = (marketing) => {
    const nullSafe = marketing || {};
    let rendered = "item(s)";

    if (nullSafe.images && nullSafe.patent) {
        rendered = "new product concept & development renditions and patent illustrations";

    } else if (nullSafe.images) {
        rendered = "new product concept & development renditions";

    } else if (nullSafe.patent) {
        rendered = "patent illustrations";
    }

    return rendered;
}

const MarketingThanksStep = (props) => {
    const { snackbar, marketing, onSaveWizard } = props;
    const [ saving, setSaving ] = useState(false);

    const markComplete = () => {
        setSaving(true);

        const success = (wizard) => {
            onSaveWizard(wizard);
            setSaving(false);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        }

        wizardService.markComplete(success, failure);
    };

    return <>
        <Typography variant="h6" paragraph={true}>
            Thank you!
        </Typography>
        <Typography paragraph={true}>
            Your {renderItems(marketing)} will be uploaded to <YourFilesLink/> soon.
        </Typography>
        <QuestionsBlurb/>
        <SpinnerButton
            color="primary"
            label="Ok"
            onClick={markComplete}
            spinner={saving}
        />
    </>
};

export default MarketingThanksStep;
